import { render, staticRenderFns } from "./ChangeStatusOrder.vue?vue&type=template&id=a31e1644"
import script from "./ChangeStatusOrder.vue?vue&type=script&lang=js"
export * from "./ChangeStatusOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports